(function () {
    'use strict';
    $(document).ready(function () {
        var moving = false;

        $('.subpage .select-wrapper .select-toggler').on('click', function (e) {
            e.preventDefault();

            if(!moving) {
                var href = $(this).attr('href');
                var targetElement = $(href);

                var wrapperHeight = targetElement.find('.wrapper').actual('height');
                var containerHeight = targetElement.find('.scroll-wrapper').actual('height');

                if (targetElement.hasClass('active')) {
                    $(this).removeClass('active');
                    moving = true;
                    targetElement.slideUp(function () {
                        moving = false;
                        targetElement.removeClass('active');
                    });

                    targetElement.find('.scroll-wrapper').mCustomScrollbar('destroy');

                } else {
                    moving = true;
                    var activeFieldset = $('fieldset.select.active');
                    if (activeFieldset.length) {
                        activeFieldset.find('.scroll-wrapper').mCustomScrollbar('destroy');
                        activeFieldset.slideUp(function () {
                            $(this).removeClass('active');

                            if(wrapperHeight > containerHeight) {
                                targetElement.find('.scroll-wrapper').mCustomScrollbar({
                                    axis: "y",
                                    mouseWheel: {
                                        enable: true
                                    }
                                });
                            }

                            targetElement.slideDown(function () {
                                moving = false;
                            });
                        });
                    }
                    else {
                        if(wrapperHeight > containerHeight) {
                            targetElement.find('.scroll-wrapper').mCustomScrollbar({
                                axis: "y",
                                mouseWheel: {
                                    enable: true
                                }
                            });
                        }
                        targetElement.slideDown(function () {
                            moving = false;
                        });
                    }

                    $('.select-toggler.active').removeClass('active');
                    $(this).addClass('active');
                    targetElement.addClass('active');
                }
            }

        });

        $('.subpage .chips .chip.all').on('click', function () {
            $('.subpage .input-wrapper input[type=text], .subpage .date-wrapper input[type=text]').val('');
            $('.subpage .select-wrapper input[type=checkbox]').prop('checked', false);
            $('.subpage .select-wrapper input[type=radio][checked]').removeAttr('checked').prop('checked', false);
            $(this).parent().find('>.chip').remove();
        });

        $('.subpage .chips .chip span.remove-chip').on('click', function () {
            var $this = $(this).parent();

            var temat_id = $this.data('temat-id');

            $('.subpage .select-wrapper input[type=checkbox][name=temat][data-value='+temat_id+']').prop('checked', false);

            $this.remove();
        });

        $('#program-fieldset input[type=radio]').on('click', function () {
            var attr = ($(this).attr('checked'));

            if(attr === 'checked') {
                $(this).removeAttr('checked').prop('checked', false);
            } else {
                $('input[type=radio][checked]').removeAttr('checked').prop('checked', false);
                $(this).attr('checked', 'checked').prop('checked', true);
            }
        });

        $('.publication-search').find('.select').each(function() {
            $(this).keypress(function (e) {
                if (e.which == 13) {
                    jQuery('button#filter').trigger('click');
                    event.preventDefault();
                }
            });
        });

    });
}(jQuery));
